module.exports = __webpack_public_path__ + "img/DSC_0818.92d05879.jpeg";